<template>
  <main class="content" role="main">
    <div class="content__wrapper">
      <content-heading>Contrast</content-heading>
    </div>
  </main>
</template>

<script>
  import ContentHeading from '@/components/content-heading';

  export default {
    name: 'contrast',
    components: {
      ContentHeading,
    },
  };
</script>


// WEBPACK FOOTER //
// src/pages/contrast/index.vue